import { Priority, PriorityAssignmentInput, PriorityStatus } from "@/types";
import type { PriorityFormValues } from "./priority-form-schema";

export function assignmentsFromPriority(initial?: Partial<Priority>) {
    if (!initial?.assignments?.length) return [];
    return initial.assignments.map((a) => ({
        userPid: a.assignedUser.pid,
        status: (a.status ?? "queue") as PriorityStatus,
        icTask: a.icTask ?? "",
        isDri: a.isDri ?? false,
        blockerUserPid: a.blocker?.pid,
        blockedReason: a.blockedReason ?? undefined,
    }));
}

export function toAssignmentPayload(values: PriorityFormValues["assignments"]): PriorityAssignmentInput[] {
    return values.map((a) => ({
        userPid: a.userPid,
        status: a.status,
        icTask: (a.icTask ?? "").trim(),
        isDri: a.isDri,
        blockerUserPid: a.blockerUserPid,
        blockedReason: a.blockedReason?.trim() ? a.blockedReason.trim() : undefined,
    }));
}
